import { schema } from 'normalizr';
import sharepointRootSchema from './sharepointRoot';

const documentSectionSchema = new schema.Entity('documentSections', {
  sharepointRoots: new schema.Array(sharepointRootSchema),
});

export default documentSectionSchema;
